const INITIAL_STATE = {
    lastPosts: {
        status: 'done',
        data: []
    }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'BLOG_LAST_POSTS_STATUS':
            return {
                    ...state,
                    lastPosts: {
                        ...state.lastPosts,
                        status: action.payload
                    }
                }
        case 'BLOG_LAST_POSTS_DATA':
            return {
                    ...state,
                    lastPosts: {
                        ...state.lastPosts,
                        data: action.payload
                    }
                }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/blogReducer.js